import React, { Component} from "react";
import Unity, { UnityContent } from "react-unity-webgl";
import { FaSpinner } from 'react-icons/fa';
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      //loadingText: 'Loading',
      ysdkIsReady: false
    };

    //const [ysdkIsReady, setYsdkIsReady] = useState(false);

    var player;
    var ysdk;
    //var ysdkIsReady = false;
    var isLogin = false;

    var currentLang = 'en_US';
    var currentLevel = 1;

    window.yagames.init().then(yasdk => {
      console.log('Yandex SDK initialized');
      ysdk = yasdk;
      //ysdkIsReady = true;
      //setYsdkIsReady(true);
      this.state.ysdkIsReady = true;

     /* ysdk.getPlayer({ scopes: false }).then(_player => {
        player = _player;

        const keys = ['currentLanguage'];
        player.getData(keys).then(data => {
            const currentLanguage = data.currentLanguage;
            console.log('currentLanguage: ' + currentLanguage);
            
            if (currentLanguage) {
              lang = currentLanguage
            }
            else {
              switch (ysdk.environment.i18n.lang) {
                case 'ru':
                  lang = 'ru_RU';
                  this.setState({
                    loadingText: 'Загрузка',
                  });
                  //this.state.loadingText = 'Загрузка';
                  console.log("lang = " + ysdk.environment.i18n.lang + " " + ysdk.environment.i18n.tld);
                  break;
                case 'kk':
                  lang = 'kz_KZ';
                  //this.state.loadingText = 'Жүктелуде';
                  this.setState({
                    loadingText: 'Жүктелуде',
                  });
                  break;
                case 'en':
                  lang = 'en_US';
                  //this.state.loadingText = 'Loading';
                  this.setState({
                    loadingText: 'Loading',
                  });
                  break;
                default:
                  lang = 'en_US';
                // this.state.loadingText = 'Loading';
                this.setState({
                  loadingText: 'Loading',
                });
                  break;
              }
            }
        }).catch(error => {
            console.error('Error retrieving data:', error);
        });
        
      }).catch(err => {
          // Ошибка при инициализации объекта Player.
      });
*/
      
      
    });

    this.unityContent = new UnityContent(
      "CookieEater/Build/xmasYandex.json",
      "CookieEater/Build/UnityLoader.js"
    );

    // Методы жизненного цикла для добавления и удаления слушателей
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    this.unityContent.on("SetOpenLevel", async (countLevels) => {
      currentLevel = countLevels;
      player.setData({
        openLevels: countLevels,
        currentLanguage: currentLang,
      }).then(() => {
          console.log('data is set');
      });
    });

    this.unityContent.on("SetLanguage", async (lang) => {
      currentLang = lang;
      player.setData({
        openLevels: currentLevel,
        currentLanguage: lang,
      }).then(() => {
          console.log('data is set');
      });
    });

    this.unityContent.on("SendYandexReady",  async () => {
      while (!this.state.ysdkIsReady) {
        await new Promise(resolve => setTimeout(resolve, 100)); // Можно использовать другие способы ожидани
        console.log("waiting yandex sdk loading");
      }
      ysdk.features.LoadingAPI.ready();
    });

  this.unityContent.on("ShowInterStitial", async () => {
		ysdk.adv.showFullscreenAdv({
        callbacks: {
          onOpen: () => {
            console.log("ads open");
            this.unityContent.send(
              "AdsController",
              "SetupAdsState"
            );
          },
          onClose: (wasShown) => {
            console.log("ads close");
            var playSound = wasShown ? 1 : 0;
            this.unityContent.send(
              "AdsController",
              "ContinueGame",
              playSound
            );
          },
          onError: (error) => {
            // Ваш код для обработки ошибки
          }
        }
    })
    console.log("ads showed");
  });

  this.unityContent.on("YandexLogin", async () => {
   // if (!isLogin) {
      isLogin = true;
      if (this.state.ysdkIsReady) {
        
        YandexLogin(); 
      }
   // }
  });

  this.unityContent.on("YandexLogOut", async () => {
    isLogin = false;
  });

  const YandexLogin = () => {
    
    ysdk.getPlayer({ scopes: true }).then(_player => {
      
      player = _player;
		if (player.getMode() === 'lite') {
      // Игрок не авторизован.
      ysdk.auth.openAuthDialog().then(() => {
              // Игрок успешно авторизован
              let yandexData = `{"id":"${player.getUniqueID()}","name":"${player.getName()}","photoUrl":"${player.getPhoto("small")}"}`;
              this.unityContent.send(
                "User",
                "YandexLogin",
                yandexData
              );
              //isLogin = true;
          }).catch(() => {
              // Игрок не авторизован.
          });
    }
    else {
      console.log("ysdkIsReady");
      let yandexData = `{"id":"${player.getUniqueID()}","name":"${player.getName()}","photoUrl":"${player.getPhoto("small")}"}`;
              this.unityContent.send(
                "User",
                "YandexLogin",
                yandexData
              );
              //isLogin = true;
      console.log("photoUrl = " + player.getPhoto("small"));
    }
    }).catch(err => {
      // Ошибка при инициализации объекта Player.
      console.log("error = " + err);
});
  }

    this.unityContent.on("loaded", async () => {
      this.setState({
        isLoaded: true,
      });

     /* this.unityContent.send(
        "User",
        "SetOpenLevelsYandex",
        15
      );*/
      while (!this.state.ysdkIsReady) {
        await new Promise(resolve => setTimeout(resolve, 100)); // Можно использовать другие способы ожидани
        console.log("waiting yandex sdk loaing");
      }

      

        ysdk.getPlayer({ scopes: false }).then(_player => {
          player = _player;
          if (isLogin) {
            YandexLogin();
          }
          else {
            this.unityContent.send(
              "User",
              "YandexLoginWithoutScopes",
              player.getUniqueID()
            );
          }

          const keys = ['openLevels', 'currentLanguage'];
          player.getData(keys).then(data => {
            //var lang = 'en_US';

            const openLevels = data.openLevels;
            console.log('Open Levels:', openLevels);
              if (openLevels) {
                currentLevel = openLevels;
              this.unityContent.send(
                "User",
                "SetOpenLevelsYandex",
                openLevels
              );
            }

            const currentLanguage = data.currentLanguage;
            console.log('currentLanguage: ' + currentLanguage);
            if (currentLanguage) {
              currentLang = currentLanguage
            }
            else {
              switch (ysdk.environment.i18n.lang) {
                case 'ru':
                  currentLang = 'ru_RU';
                  break;
                case 'kk':
                  currentLang = 'kz_KZ';
                  break;
                case 'en':
                  currentLang = 'en_US';
                  break;
                default:
                  currentLang = 'en_US';
                  break;
              }
            }
            this.unityContent.send(
              "LocalizationManager",
              "LoadLocalizedTextCoroutine",
              currentLang
            );

          }).catch(error => {
              console.error('Error retrieving data:', error);
          });
          
        }).catch(err => {
            // Ошибка при инициализации объекта Player.
            this.unityContent.send(
              "LocalizationManager",
              "LoadLocalizedTextCoroutine",
              'en_US'
            );
        });
      
     /* window.yagames.init().then(yasdk => {
        console.log('Yandex SDK initialized');
        ysdk = yasdk;
        ysdkIsReady = true;
        ysdk.features.LoadingAPI.ready();
        ysdk.getPlayer({ scopes: false }).then(_player => {
          player = _player;
          if (isLogin) {
            YandexLogin();
          }
          else {
            this.unityContent.send(
              "User",
              "YandexLoginWithoutScopes",
              player.getUniqueID()
            );
          }

          const keys = ['openLevels'];
          player.getData(keys).then(data => {
              const openLevels = data.openLevels;
              console.log('Open Levels:', openLevels);
              this.unityContent.send(
                "User",
                "SetOpenLevelsYandex",
                openLevels
              );
          }).catch(error => {
              console.error('Error retrieving data:', error);
          });
          
        }).catch(err => {
            // Ошибка при инициализации объекта Player.
        });
      });*/
      //}
    });

  }

  componentDidMount() {
    window.addEventListener('blur', this.handleBlur);
    window.addEventListener('focus', this.handleFocus);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.handleBlur);
    window.removeEventListener('focus', this.handleFocus);
  }
  
  handleBlur () {
    console.log('Страница свернута');
    // Ваш код для обработки события свертывания
    this.unityContent.send(
      "MusicManager",
      "PauseMusic"
    );
    this.unityContent.send(
      "AudioManager",
      "MuteAudio"
    );
  };

  handleFocus()  {
    console.log('Страница развернута');
    // Ваш код для обработки события развертывания
    this.unityContent.send(
      "MusicManager",
      "UnPauseMusic"
    );
    this.unityContent.send(
      "AudioManager",
      "UnMuteAudio"
    );
  };

  render() {
    var contents = this.state.isLoaded ? (
      <div>
        
      </div>
    ) : <div className="Loading-component"><div className="loading-icon">
    <FaSpinner className="spin large-icon" />
  </div></div>;

    return ( 
      <div className="App">
        <div className="App-container">
          <Unity unityContent={this.unityContent} width="100%" height="100%" />
          {contents}
        </div>
      </div>
    );
  }
}

export default App;
